'use client';

import { defineMessage, useIntl } from 'react-intl';
import { SlotLink } from './Slot.Link';

const title = defineMessage({
  id: 'slot.payback.label',
  defaultMessage: 'PAYBACK',
});

export const PaybackSlot = () => {
  const { formatMessage } = useIntl();

  return (
    <SlotLink href="/service-hilfe/bestellen-beraten/payback" label={formatMessage(title)}>
      <div className="icon-emp-payback-colored h-4 w-4" />
    </SlotLink>
  );
};
